import successSound from '../assets/sounds/success.mp3';

export const playSuccessSound = () => {
  const audio = new Audio(successSound);
  audio.volume = 0.6; // Set volume to 60%
  audio.play().catch(() => {});
};
